import styled, { css } from 'styled-components';

import home_banner from 'assets/img/home_banner.png';
import splash_exagon from 'assets/splash_exagon.svg';

export const Container = styled.div``;

export const Content = styled.div`
  width: 100%;

  margin: 0 auto;

  padding: 15px;

  @media (min-width: 1170px) {
    padding-left: 250px;
  }
`;

export const WellcomeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;

  width: 100%;
  max-width: 1100px;

  margin: 0 auto;

  padding: 2em 0;
`;

export const Wellcome = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 15px;

  width: 400px;

  .wellcome__message {
    font-size: 32px;
    color: #252731;
  }

  .wellcome__message__strong {
    color: var(--blue12);
    font-weight: 600;
  }

  .wellcome__message__description {
    font-size: 1.1rem;
  }
`;

export const ProfileSection = styled.section`
  color: #fff;

  margin: 0 auto;
  padding: 3em 0 0;

  background-color: var(--blue12);
  border-radius: 0 50px 0 0;

  .profile-section__first-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 30px 15px;

    width: 100%;
    max-width: 1100px;

    margin: 0 auto;
  }

  .profile__wrapper {
    width: 100%;
    max-width: 300px;
  }

  @media (max-width: 1290px) {
    .profile-section__first-row {
      gap: 30px 40px;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 100%;
  max-width: 300px;

  .profile__title-wrapper {
    max-width: 350px;
  }

  .profile__title{
    font-size: 1.5rem;
    color: #fff;
  }

  .profile__title-service-name{
    margin-top: 25px;

    color: #fff;
    font-size: 2.5625rem;
    font-weight: bold;
  }
`;

export const Docs = styled.div`
  margin-top: 26.4px;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;

  .docs__documentation-button{
    width: 100%;
    height: 60px;
    margin-top: 10px;

    border-radius: 30px;
    text-align: center;
    vertical-align: middle;
    border: 0;
    font-size: 1.2rem;
    line-height: 60px;
    color: #fff;
    background-color: var(--blue2f);

    transition: all 0.5s ease-in-out;
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .file-input__label {
    margin-top: 10px;
  }
`;

export const AttendanceCard = styled.div`
  width: 100%;
  max-width: 680px;
  min-height: 270px;
  padding: 15px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 15px;

  color: #fff;
  font-size: 1rem;

  background-color: #3d91ff70;
  border-radius: 15px;
  box-shadow: 0 3px 6px rgb(0 0 0 /16%);

  .attendance-card__title {
    font-size: 1.8rem;
  }

  .attendance-card__text{
    width: 100%;
    max-width: 440px;

    font-size: 1.1rem;
    line-height: 1.9rem;
  }

  .attendance-card__closing-indicator {
    margin-left: auto;

    strong {
      font-weight: bold;
    }
  }
`;

export const Toggle = styled.div`
  .toggle__wrapper {
    display: flex;
    align-items: center;

    width: 100px;
    height: 50px;

    padding: 3px;

    border-radius: 30px;

    background-color: #adacac;

    cursor: pointer;

    transition: all 0.2s ease-in-out;
  }

  .active {
    background-color: #00FF11;
  }

  .toggle__wrapper__pin {
    width: 43px;
    height: 43px;

    margin-left: 2%;

    background-color: #fff;
    box-shadow: 0 3px 6px rgb(0 0 0 /16%);
    border-radius: 30px;

    transition: all 0.3s ease-in-out;
  }

  .pin-active {
    margin-left: 52%;
  }
`;

export const BannerWrapper = styled.div`
  position: relative;
  z-index: 2;

  width: 100%;
  max-width: 1055px;

  margin: 0 auto;
  .hex {
    content: '';

    position: absolute;
    bottom: 62%;
    left: -15px;
    z-index: -1;

    width: 205px;
    height: 205px;

    transform: rotate(39deg);

    background: no-repeat center;
    background-size: contain;
    background-image: url(${splash_exagon});
  }
`;

export const Banner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  width: 100%;
  max-width: 1055px;
  min-height: 180px;

  margin: 6em auto;
  padding: 1.5em;

  font-size: 1.7rem;
  color: #fff;

  span {
    display: inline-block;
    width: 100%;
    max-width: 170px;
    line-height: 2rem;
  }

  strong {
    font-weight: bold;
  }

  background: no-repeat center;
  background-size: cover;
  background-image: url(${home_banner});
`;

const Active = css`
  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;

  ${({ active }: { active: boolean }) => active && Active}

  .show-message {
    display: flex !important;
  }

  .overlay__message-wrapper {
    display: none;
    flex-direction: column;
    gap: 15px;

    padding: 15px;

    color: var(--blue12);
    font-size: 1.5rem;
    text-align: center;
  }

  span {
    font-size: 1.3rem;
    padding: 10px 30px;
  }

  strong {
    font-weight: bold;
    cursor: pointer;
  }

  .overlay__message__button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    max-width: 745px;
    min-height: 105px;

    font-size: 1.7rem;
    color: #fff;
    text-align: center;

    padding: 15px 30px;

    box-shadow: 0 3px 6px rgb(0 0 0 /16%);
    background-color: var(--blue12);

    border-radius: 55px;

    transition: all 0.5s ease-in;
    cursor: pointer;
    &:hover {
      filter: brightness(1.1);
    }
  }
`;

